import { Injectable } from '@angular/core';
import {BehaviorSubject, Observable, Subscription, timer} from 'rxjs';
import {SharedDataService} from "./shared-data.service";
import {HttpClient} from "@angular/common/http";
import {environment} from "../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class SessionTimerService {
  private countdown: number = 0;
  private countdownSubject: BehaviorSubject<number> = new BehaviorSubject<number>(this.countdown);
  private countdownSubscription!: Subscription;
  private extendSessionUrl = environment.apiBaseUrl + '/internalApi/extendSession';
  private sessionTimeOutUrl = environment.apiBaseUrl + '/internalApi/sessionTimeout';


  constructor(private sharedDataService: SharedDataService,
              private http: HttpClient) {}

  resetSessionTimer(timeout: number): void {
    if (timeout) {
      this.sharedDataService.getSessionExpired().subscribe(isExpired => {
        if (!isExpired) {
          this.countdown = timeout;
          this.countdownSubject.next(this.countdown);
        }
      });
    }
  }

  getRemainingTime(): Observable<number> {
    return this.countdownSubject.asObservable();
  }

  public startSessionTimer(timeout: number): void {
    this.resetSessionTimer(timeout);

    this.countdownSubscription = timer(0, 1000).subscribe(() => {
      if (this.countdown > 0) {
        this.countdown--;
        this.countdownSubject.next(this.countdown);
      } else {
        this.sharedDataService.setSessionExpired(true);
        this.stopTimer();
      }
    });
  }

  private stopTimer(): void {
    if (this.countdownSubscription) {
      this.countdownSubscription.unsubscribe();
    }
  }

  extendSession(): void {
    this.http.get(this.extendSessionUrl, {
      withCredentials: true,
      responseType: 'text'
    }).subscribe(
      (response) => {
        console.log('Response from backend:', response);
      },
      (error) => {
        this.sharedDataService.setKlaidos(error.error);
      }
    );
  }

  getSessionTimeout(): Observable<number> {
    return this.http.get<number>(this.sessionTimeOutUrl, { withCredentials: true });
  }
}
